/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sectorIndicesGet } from "../../funcs/sectorIndicesGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetAssetClassIndexRequest$inboundSchema,
};

export const tool$sectorIndicesGet: ToolDefinition<typeof args> = {
  name: "sector-indices-get",
  description: `Get the proprietary value of the sector index requested

Return the selected sector or asset class index historical values using a proprietary methodology and composition`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sectorIndicesGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
